import { Routes, Route, Link } from 'react-router-dom'

function SubEventEnd1() {
    return(
        <>
            <div className='event-ongoing-subpage'>
              <div className='event-ongoing-subpage-subject'>
                <h1>수다왕 이벤트</h1>
                <p>2024-01-25 ~ 2024-02-01</p>
              </div>
              <div className='event-ongoing-subpage-img'><img src={process.env.PUBLIC_URL + '/img/.png'} /></div>
            </div>
        </>
    )
}

export default SubEventEnd1;